import { Snackbar, SnackbarOrigin } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import clsx from "clsx";
import { SeverityMessage } from "../../models/alertMessage";
import useStyle from "./toast-message.styles";

interface ToastMessageProps {
  isOpen: boolean;
  handleClose: () => void;
  className?: string;
  severity: SeverityMessage;
  message: string;
  orientation?: SnackbarOrigin;
  autoHideDuration?: number;
}

export const ToastMessage = (props: ToastMessageProps) => {
  const {
    isOpen,
    severity,
    handleClose,
    className,
    message,
    orientation,
    autoHideDuration,
  } = props;
  const classes = useStyle();
  const isErrorMessage = severity === "error";
  const isSuccessMessage = severity === "success";

  return (
    <Snackbar
      anchorOrigin={orientation}
      open={isOpen}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      className={clsx({
        [classes.snackbarSuccess]: isSuccessMessage,
        [classes.snackbarError]: isErrorMessage,
        [className]: className,
      })}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        className={classes.alert}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

ToastMessage.defaultProps = {
  orientation: { vertical: "top", horizontal: "center" },
  className: "",
  autoHideDuration: 3000,
};
